import { InternalApiAxiosInstance } from '../../config/axios/internal.api.config';
import { ServiceHandler } from '../../utils';
import type { PasswordConstraintsDto } from './auth.dto';

export const login = ServiceHandler(
  {
    url: '/api/auth/v1/login',
    method: 'post',
  },
  InternalApiAxiosInstance
);

export const loginSso = (username: string) => {
  window.location.href = constructSsoUrl(username);
};

export const constructSsoUrl = (username: string) => {
  const baseUrl = window.location.origin;
  return `${baseUrl}/api/auth/v1/sso?username=${encodeURIComponent(username)}`;
};

export const getIsSsoEnabled = ServiceHandler<unknown, { enabled: boolean }>({
  url: '/api/auth/v1/sso/enabled/:username',
});

export const getPasswordConstraints = ServiceHandler<
  unknown,
  PasswordConstraintsDto[]
>(
  {
    url: '/api/auth/v1/password-constraints',
  },
  InternalApiAxiosInstance
);

export const getAccessToken = ServiceHandler({
  url: '/api/auth/v1/access',
  method: 'POST',
});

export type MagicLinkRequestPayload = {
  email: string;
  captchaToken: string;
};

export type MagicLinkRequestResponse = {
  status: 'sent' | 'sso_required';
  ssoUrl?: string;
};

export const magicLinkRequest = ServiceHandler<
  MagicLinkRequestPayload,
  MagicLinkRequestResponse
>(
  {
    url: '/api/auth/v1/login/magic/request',
    method: 'post',
  },
  InternalApiAxiosInstance
);

export type MagicLinkConsumePayload = {
  token: string;
};

export const magicLinkConsume = ServiceHandler<MagicLinkConsumePayload>(
  {
    url: '/api/auth/v1/login/magic/consume',
    method: 'post',
  },
  InternalApiAxiosInstance
);

export type GetLatestDeploymentTimeResp = {
  latestDeploymentTime: string;
};

export const logout = ServiceHandler<unknown, void>(
  {
    url: '/api/auth/v1/logout',
    method: 'POST',
    withCredentials: true,
  },
  InternalApiAxiosInstance
);

export const getLatestDeploymentTime = ServiceHandler<
  unknown,
  GetLatestDeploymentTimeResp
>({
  url: '/latest-deployment-time',
  method: 'GET',
});
